export default {
  getRepliquesTableHeaders(state) {
    return state.repliquesTableHeaders;
  },
  getRepliquesTableItems(state) {
    return state.repliquesTableItems;
  },
  getFiltros(state) {
    return state.filtros;
  },
};
